export default "__VITE_ASSET__DKlI49KX__"